import { gql } from "@/gql";

export const GET_WORKER_ALLOWED_SERVICES = gql(`
  query GetWorkerAllowedServices($workerSalonId: ID!) {
    getWorkerAllowedServices(workerSalonId: $workerSalonId) {
      id
      name
      categoryId
      category {
        id
        name
      }
    }
  }
`);

export const UPDATE_WORKER_SERVICE_RESTRICTION = gql(`
  mutation UpdateWorkerServiceRestriction($input: UpdateWorkerServiceRestrictionInput!) {
    updateWorkerServiceRestriction(input: $input) {
      id
      serviceRestrictionMode
    }
  }
`);

export const REMOVE_WORKER_SERVICE_RESTRICTIONS = gql(`
  mutation RemoveWorkerServiceRestrictions($workerSalonId: ID!) {
    removeWorkerServiceRestrictions(workerSalonId: $workerSalonId)
  }
`);
